export class MobileHelper {

    private mobileMode: boolean;

    constructor() {
        this.mobileMode = $(window).width() < 850 ? true : false;
        $(window).resize(() => {
            const mobile = $(window).width() < 850 ? true : false;
            if (mobile !== this.mobileMode) {
                this.mobileMode = mobile;
            }
        });
    }

    public get IsMobileMode() {
        return this.mobileMode;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/mobile-helper.ts